import React from "react";
import { OwcTooltip } from "@one/react";
import { emptyValueSign } from "./FilterContent";

const stripWamPrefix = (value) => {
  if (!value) return "";
  return value.replace(/^wam[a-z0-9-]*\.roche\.com_?\\?/i, "");
};

export const UserNameRenderer = ({ item }) => {
  const value = item.modifiedBy;
  const normalized = stripWamPrefix(value);
  return <span title={value}>{normalized}</span>;
};

export const AssignedGroupsRenderer = ({ item }) => {
  const tooltipId = React.useMemo(() => `tooltip-${Math.random().toString(36).slice(2, 11)}`, []);

  return (
    <>
      <div
        id={tooltipId}
        style={{
          textOverflow: "ellipsis",
          overflow: "hidden",
          fontWeight: "500",
          whiteSpace: "nowrap",
          flex: "0 1 14%",
          paddingRight: "15px",
          paddingLeft: "5px",
          maxWidth: "200px",
        }}
      >
        {item.assignedGroups}
      </div>
      {item.assignedGroups !== emptyValueSign && (<OwcTooltip anchor={tooltipId} placement="bottom">
        {item.assignedGroups}
      </OwcTooltip>)}
    </>
  );
};
